export const SvgVector = (props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 13.5C15.8284 13.5 16.5 12.8284 16.5 12C16.5 11.1716 15.8284 10.5 15 10.5C14.1716 10.5 13.5 11.1716 13.5 12C13.5 12.8284 14.1716 13.5 15 13.5Z"
        fill="white"
      />
      <path
        d="M15 25.5C15.8284 25.5 16.5 24.8284 16.5 24C16.5 23.1716 15.8284 22.5 15 22.5C14.1716 22.5 13.5 23.1716 13.5 24C13.5 24.8284 14.1716 25.5 15 25.5Z"
        fill="white"
      />
      <path
        d="M21 13.5C21.8284 13.5 22.5 12.8284 22.5 12C22.5 11.1716 21.8284 10.5 21 10.5C20.1716 10.5 19.5 11.1716 19.5 12C19.5 12.8284 20.1716 13.5 21 13.5Z"
        fill="white"
      />
      <path
        d="M21 25.5C21.8284 25.5 22.5 24.8284 22.5 24C22.5 23.1716 21.8284 22.5 21 22.5C20.1716 22.5 19.5 23.1716 19.5 24C19.5 24.8284 20.1716 25.5 21 25.5Z"
        fill="white"
      />
      <path
        d="M21 19.5C21.8284 19.5 22.5 18.8284 22.5 18C22.5 17.1716 21.8284 16.5 21 16.5C20.1716 16.5 19.5 17.1716 19.5 18C19.5 18.8284 20.1716 19.5 21 19.5Z"
        fill="white"
      />
      <path
        d="M15 19.5C15.8284 19.5 16.5 18.8284 16.5 18C16.5 17.1716 15.8284 16.5 15 16.5C14.1716 16.5 13.5 17.1716 13.5 18C13.5 18.8284 14.1716 19.5 15 19.5Z"
        fill="white"
      />
    </svg>
  );
};
export const ExpandMoreSvg = (props) => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14 0L7 8L0 0H14Z"
        fill="white"
      />
    </svg>
  );
};

export const EditSvg = (props) => {
  return (
    <svg
      style={{ ...props.style }}
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2887 4.99643L16.7185 1.42627L2.43783 15.7069L1.00977 20.7052L6.008 19.2771L20.2887 4.99643ZM13.8624 4.2824L17.4325 7.85257L13.8624 4.2824ZM2.43783 15.7069L6.008 19.2771L2.43783 15.7069Z"
        stroke="#717579"
        stroke-width="1.63208"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DeleteSVg = (props) => {
  return (
    <svg
      style={props.style}
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.67014 0.629883C9.45354 0.629812 10.2071 0.930187 10.7757 1.46913C11.3442 2.00807 11.6844 2.74454 11.7262 3.52682L11.7303 3.69002H16.2185C16.3736 3.69007 16.5228 3.74898 16.6361 3.85484C16.7494 3.9607 16.8183 4.10563 16.8289 4.26034C16.8395 4.41504 16.7909 4.56799 16.6931 4.68828C16.5952 4.80857 16.4553 4.88723 16.3017 4.90837L16.2185 4.91408H15.3543L14.3587 17.1979C14.2966 17.9642 13.9483 18.6791 13.3831 19.2003C12.8179 19.7215 12.0772 20.0108 11.3084 20.0108H6.03189C5.26306 20.0108 4.52238 19.7215 3.95717 19.2003C3.39197 18.6791 3.04367 17.9642 2.98154 17.1979L1.98516 4.91408H1.12179C0.973897 4.91407 0.831006 4.86051 0.719544 4.7633C0.608083 4.66609 0.535592 4.53181 0.515478 4.38529L0.509766 4.30205C0.509772 4.15416 0.563333 4.01126 0.660543 3.8998C0.757753 3.78834 0.892035 3.71585 1.03856 3.69574L1.12179 3.69002H5.61C5.61 2.87842 5.93241 2.10007 6.5063 1.52618C7.08018 0.95229 7.85854 0.629883 8.67014 0.629883ZM14.127 4.91408H3.2133L4.20152 17.0992C4.23884 17.5589 4.44786 17.9878 4.78701 18.3005C5.12616 18.6132 5.57059 18.7868 6.03189 18.7867H11.3084C11.7697 18.7868 12.2141 18.6132 12.5533 18.3005C12.8924 17.9878 13.1015 17.5589 13.1388 17.0992L14.1262 4.91408H14.127ZM6.83406 7.97422C6.98196 7.97423 7.12485 8.02779 7.23631 8.125C7.34777 8.22221 7.42026 8.35649 7.44037 8.50301L7.44609 8.58625V15.1146C7.44604 15.2696 7.38713 15.4189 7.28127 15.5322C7.17541 15.6455 7.03048 15.7144 6.87577 15.725C6.72107 15.7355 6.56812 15.687 6.44783 15.5891C6.32754 15.4913 6.24888 15.3514 6.22774 15.1978L6.22203 15.1146V8.58625C6.22203 8.42393 6.28651 8.26826 6.40129 8.15348C6.51607 8.0387 6.67174 7.97422 6.83406 7.97422ZM10.5062 7.97422C10.6541 7.97423 10.797 8.02779 10.9085 8.125C11.0199 8.22221 11.0924 8.35649 11.1125 8.50301L11.1183 8.58625V15.1146C11.1182 15.2696 11.0593 15.4189 10.9534 15.5322C10.8476 15.6455 10.7027 15.7144 10.5479 15.725C10.3932 15.7355 10.2403 15.687 10.12 15.5891C9.99971 15.4913 9.92105 15.3514 9.89991 15.1978L9.8942 15.1146V8.58625C9.8942 8.42393 9.95868 8.26826 10.0735 8.15348C10.1882 8.0387 10.3439 7.97422 10.5062 7.97422ZM8.67014 1.85394C8.2049 1.85388 7.75698 2.03044 7.41691 2.34794C7.07684 2.66544 6.86998 3.1002 6.83814 3.56435L6.83406 3.69002H10.5062L10.5021 3.56435C10.4703 3.1002 10.2634 2.66544 9.92338 2.34794C9.58331 2.03044 9.13539 1.85388 8.67014 1.85394Z"
        fill="#717579"
      />
    </svg>
  );
};
